import { render, staticRenderFns } from "./rules-modal-step5.vue?vue&type=template&id=31be1a97&scoped=true&"
import script from "./rules-modal-step5.vue?vue&type=script&lang=js&"
export * from "./rules-modal-step5.vue?vue&type=script&lang=js&"
import style0 from "./rules-modal-step5.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./rules-modal-step5.vue?vue&type=style&index=1&id=31be1a97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be1a97",
  null
  
)

export default component.exports